import React from "react";
import { Avatar, Divider, IconButton, Tooltip } from "@mui/material";
import { EditRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { formatDate } from "hooks";

const SupplierInfo = ({ supplier }) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/supplier_form/${supplier.id}`);
  };

  const renderLabel = (label, value) =>
    value ? (
      <>
        <div className="flex flex-wrap j-between items-center mt-[10px] mb-[10px]">
          <span className="text-[15px] mr-[30px]">{label} :</span>
          <span className="text-[15px]">{value}</span>
        </div>
        <Divider />
      </>
    ) : (
      ""
    );

  return (
    <>
      {supplier ? (
        <div className="grid bg-white p-[10px] rounded-[15px] text-gray-500">
          <div className="text-right">
            <Tooltip title="Edit Member">
              <IconButton
                onClick={handleEdit}
                size="small"
                color="primary"
                sx={{ border: "1px solid var(--primarySM-color)" }}
              >
                <EditRounded className="text-[20px] p-[2px]" />
              </IconButton>
            </Tooltip>
          </div>
          <div className="flex justify-center mb-[10px]">
            <Avatar
              src={supplier.photo}
              alt="profile_pic"
              className="object-cover"
              sx={{ width: "110px", height: "110px" }}
            />
          </div>
          <div className="grid gap-[10px] justify-center">
            <div className="tx-center">
              <p className="text-[28px] m-[0px] mb-[5px] font-medium">
                {supplier.splrName}
              </p>
              <p className="text-[12px] text-gray-400 m-[0px]">
                Supplier scince: {formatDate(supplier.createDate)}
              </p>
            </div>
          </div>
          <div className="p-[10px]">
            <div className="flex items-center mt-[40px] mb-[15px]">
              <span className="text-[12px] italic uppercase font-bold tracking-widest underline">
                Personal Details
              </span>
            </div>
            {renderLabel("Default Markup", `${supplier.defMarkup}%`)}
            {renderLabel("Company", supplier.company)}
            {renderLabel("Phone", supplier.phone)}
            {renderLabel("Email", supplier.email)}
            {renderLabel("Fax", supplier.fax)}
            {renderLabel("Webstie", supplier.website)}
          </div>
        </div>
      ) : (
        "Loading..."
      )}
    </>
  );
};

export default SupplierInfo;
